import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import React from "react";
import { MenuOptionType } from "../../../../../../controls";
import { Profile } from "../../../models/Profile";

type Props = {
	setProfileId: Function;
	setShowDeleteModal: Function;
	setShowCreateModal: Function;
	setShowCloneModal: Function;
	setModalProceduresProfile: Function;
};
export const useProfilesOptionsFunctions = ({
	setProfileId,
	setShowDeleteModal,
	setShowCreateModal,
	setShowCloneModal,
	setModalProceduresProfile,
}: Props) => {
	const getMenuOptions = (data: Profile) => {
		let options: MenuOptionType[] = [];
		if (!data) {
			options = options.concat([
				{
					name: "New Profile",
					key: "new_profile",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
			]);
		} else {
			options = options.concat([
				{
					name: "New Profile",
					key: "new_profile",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
				{
					name: "Edit Profile",
					key: "edit_profile",
					onClick: () => {
						setProfileId(data);
						setModalProceduresProfile(true);
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Profile",
					key: "delete_profile",
					onClick: () => {
						setProfileId(data);
						setShowDeleteModal(true);
					},
					icon: <DeleteIcon />,
				},
				{
					name: "Clone Profile",
					key: "clone_profile",
					onClick: () => {
						setProfileId(data);
						setShowCloneModal(true);
					},
					icon: <ContentCopyIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
